export default {"src":"/_next/static/media/XELA.dc697f5c.svg","height":18,"width":18};